// Enum de valores con su CU correspondiente
const ResponsablesEnum = Object.freeze({
  seguridadHigiene: 1,
  representanteMedicinaLaboral: 2,
  representanteEmpleador: 3,
  contactoEmpresa: 4,

});

export default ResponsablesEnum;